import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { EventEmitter } from 'events';
import ReactModal from 'react-modal';

import Header from '../../appointments/appointmentForm/header';
import ClockInContainer from '../containers/ClockInContainer';
import { shouldOpenClockInModal } from '../selectors';

class ClockInModal extends Component {
  state = { opened: false }

  componentDidMount() {
    EventEmitter.prototype.on('open-clock-in-modal', this.openModal);
    EventEmitter.prototype.on('close-clock-in-modal', this.closeModal);
  }

  componentWillReceiveProps(nextProps) {
    // open modal if props are aOk
    if (nextProps.openModal === true && this.props.openModal === false) {
      this.openModal();
    }
  }

  componentWillUnmount() {
    EventEmitter.prototype.removeListener('open-clock-in-modal', this.openModal);
    EventEmitter.prototype.removeListener('close-clock-in-modal', this.closeModal);
  }

  openModal = () => {
    this.setState({ opened: true });
  }

  closeModal = () => {
    this.setState({ opened: false });
  }

  render() {
    return (
      <ReactModal
        className={{
          base: 'remodal remodal-is-initialized remodal-is-opening u-animation-fill-mode-none',
          afterOpen: 'remodal-is-opened',
          beforeClose: 'remodal-is-closing',
        }}
        overlayClassName={{
          base: 'remodal-overlay remodal-wrapper remodal-is-initialized remodal-is-opening u-animation-fill-mode-none',
          afterOpen: 'remodal-is-opened',
          beforeClose: 'remodal-is-closing',
        }}
        closeTimeoutMS={150}
        onRequestClose={this.closeModal}
        contentLabel="Modal"
        shouldCloseOnOverlayClick
        isOpen={this.state.opened}
        ariaHideApp={false}
      >
        <Header title="Clock in" onClose={this.closeModal} />
        <div className="u-ph u-pv-">
          <ClockInContainer />
        </div>
      </ReactModal>
    );
  }
}

ClockInModal.propTypes = {
  openModal: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  openModal: shouldOpenClockInModal(state),
});

export default connect(mapStateToProps)(ClockInModal);
